module.exports = __webpack_public_path__ + "static/newavi-3303fbf4a17a6c7df24fd62ca96788bb.jpg";